import React from 'react';
import clsx from 'clsx';
import {faInbox} from '@netx/core-icons';
import {
	type ExtendFormDialogProps,
	FormDialog,
} from '@netx/core-components/FormDialog';
import {
	composeClasses,
	styled,
	type WithClasses,
} from '@netx/core-components/Theme';
import {CartsSavedActionLabel, CartsSavedTitle} from '../../locales';
import {SavedCartManager, type SavedCartManagerProps} from './SavedCartManager';
import {
	getSavedCartManagerDialogUtilityClass,
	SAVED_CART_MANAGER_DIALOG_NAME,
	savedCartManagerDialogClasses,
	type SavedCartManagerDialogClasses,
} from './savedCartManagerDialogClasses';

type SavedCartManagerOwnerState = WithClasses<SavedCartManagerDialogClasses>;

const useUtilityClasses = (state: SavedCartManagerOwnerState) => {
	const {classes} = state;
	const slots = {
		root: ['root'],
	};
	return composeClasses(slots, getSavedCartManagerDialogUtilityClass, classes);
};

const SavedCartManagerDialogRoot = styled(FormDialog, {
	name: 'SavedCartManagerDialog',
	slot: 'Root',
})(({theme}) => ({}));

export interface SavedCartManagerDialogProps extends ExtendFormDialogProps<SavedCartManagerProps> {
	loading?: boolean;
}

export const SavedCartManagerDialogPrimitive = ({
	classes: _classes,
	className,
	open,
	form,
	loading,
	onClose,
	onSubmit,
	FormDialogProps,
	DialogProps,
	...props
}: SavedCartManagerDialogProps) => {
	const classes = useUtilityClasses({classes: _classes});

	return (
		<SavedCartManagerDialogRoot
			className={clsx(classes.root, className)}
			open={open}
			error={form.formState.errors.root?.message}
			isDirty={form.formState.isDirty}
			isValid={form.formState.isValid}
			isSubmitting={form.formState.isSubmitting}
			confirmLabel={CartsSavedActionLabel.SAVE}
			title={CartsSavedTitle.RENAME}
			{...FormDialogProps}
			onSubmit={(event) => {
				event.preventDefault();
				onSubmit?.(event);
			}}
			DialogProps={{
				disableContentPadding: true,
				fullScreenWhenMobile: true,
				fullWidth: true,
				icon: faInbox,
				isWorking: loading,
				maxWidth: 'xs',
				preventBackdropClose: true,
				...DialogProps,
			}}
			onClose={onClose}
		>
			<SavedCartManager {...props} form={form} />
		</SavedCartManagerDialogRoot>
	);
};

export const SavedCartManagerDialog = SavedCartManagerDialogPrimitive;

export default SavedCartManagerDialog;
